// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"68c1023d","732":"6039190f","977":"ab5a4999"}[chunkId] + ".chunk.js";
};